import { render, staticRenderFns } from "./DesignMarket.vue?vue&type=template&id=2314b064&scoped=true&"
import script from "./DesignMarket.js?vue&type=script&lang=js&"
export * from "./DesignMarket.js?vue&type=script&lang=js&"
import style0 from "./DesignMarket.vue?vue&type=style&index=0&id=2314b064&lang=scss&scoped=true&"
import style1 from "./DesignMarket.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2314b064",
  null
  
)

export default component.exports